/**
 * Determines whether a report type selection is valid against the centrally loaded allowed list.
 *
 * @param reportTypeValue - The current report type value from the hierarchy.
 * @param allowedReportTypes - The allowed report types loaded into app settings.
 * @returns `true` when the value is non-blank and present in the allowed list.
 */
export const isValidReportTypeSelection = (
  reportTypeValue: string | undefined,
  allowedReportTypes: string[],
): boolean => {
  return (
    reportTypeValue !== undefined &&
    reportTypeValue !== "" &&
    allowedReportTypes.includes(reportTypeValue)
  );
};
